import React from 'react';

/** Form state for the create / edit client drawer. */
export function useClientForm({ users, setOpen, isEdit, client, setClient }) {
    const gerenteUsers = users ? users?.filter((user) => user.userType === 'gerente') : [];
    const asesorUsers = users ? users?.filter((user) => user.userType === 'asesor') : [];

    const [name, setName] = React.useState('');
    const [rif, setRif] = React.useState('');
    const [channel, setChannel] = React.useState('moderno');
    const [asesores, setAsesores] = React.useState(['']);

    const [gerente, setGerente] = React.useState('');

    const onCloseDrawer = () => {
        setName('');
        setRif('');
        setChannel('');
        setGerente('');
        setAsesores(['']);
        setClient(null);
        setOpen(false);
    };

    React.useEffect(() => {
        if (isEdit) {
            setName(client?.name ?? '');
            setRif(client?.rif ?? '');
            setChannel(client?.channel ?? '');
            const initialAsesores = Array.isArray(client?.asesor) && client.asesor.length > 0 ? client.asesor : [''];
            setAsesores(initialAsesores);
            setGerente(client?.gerente?.toString() ?? '');
        } else {
            setName('');
            setRif('');
            setChannel('');
            setGerente('');
            setAsesores(['']);
        }
    }, [setOpen, client, isEdit]);

    const selectedGerente = gerenteUsers.find((u) => u._id === gerente);
    const gerenteValue = selectedGerente ? { value: gerente, label: selectedGerente?.name ?? '' } : undefined;

    const setAsesorAt = (index, value) => {
        const newAsesores = [...asesores];
        newAsesores[index] = value;
        setAsesores(newAsesores);
    };

    const removeAsesorAt = (index) => {
        const newAsesores = asesores.filter((_, idx) => idx !== index);
        setAsesores(newAsesores.length > 0 ? newAsesores : ['']);
    };

    const addAsesor = () => setAsesores([...asesores, '']);

    return {
        gerenteUsers,
        asesorUsers,
        name,
        setName,
        rif,
        setRif,
        channel,
        setChannel,
        asesores,
        gerente,
        setGerente,
        gerenteValue,
        setAsesorAt,
        removeAsesorAt,
        addAsesor,
        onCloseDrawer
    };
}
